export const Delimiter = () => {
  return <span style={{ margin: '0 4rem' }}>|</span>
}
